<template>
  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
    <div class="flex-grow">
      <div class="flex gap-2" @click="this.onClickTitle">
        <slot name="titleIcon"/>
        <h3 class="text-2xl leading-6 font-medium text-gray-900 pb-0">{{title}}</h3>
      </div>
      <p class="mt-1 max-w-2xl text-xs text-gray-500">
        {{subtitle}}
      </p>
    </div>
    <div v-if="hasSlot" class="flex mt-1 sm:mt-0 sm:col-span-2 max-w-lg sm:max-w-xs pb-2 sm:pb-0">
      <div class="sm:flex-grow"/>
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
    props: [
        'title',
        'subtitle',
        'titleLink'
    ],
    computed: {
      hasSlot: function() {
        return this.$slots.default;
      }
    },
    methods: {
      onClickTitle: function() {
        if (this.titleLink) {
          this.$router.push(this.titleLink)
        }
      }
    }
}
</script>